import { actions } from '../../actions/registration/registration';

export default function registration ( initialState = {}, action ) {
    const newState = {...initialState};

    switch (action.type) {

        case actions.POST_REGISTRATION_FORM:
            return postRegistration(newState, action.registration);
            break;

        default:
            return newState;
    }
}

function postRegistration(newState, registration) {
    newState.registration = {
        ...registration,
        first_name: registration.first_name,
        last_name: registration.last_name,
        email: registration.email,
        phone_number: registration.phone_number,
        password: registration.password,
        password_confirmation: registration.password_confirmation,
    };

    return newState;
}




// WEBPACK FOOTER //
// src/client/reducers/registration/registration.js